import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=29b02d31"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports